import React from "react";
import styles from "./switch.module.scss";
import IComponentProps from "../../common/component-props";
import { IFormField } from "../../../../utils/form-utils";

interface ISwitchProps extends IComponentProps {
  testId: string;
  checked?: boolean | null;
  label?: string;
  field?: IFormField<boolean>;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
}

export function Switch(props: ISwitchProps) {
  const checked = props.field ? props.field.value : props.checked;
  const onChange = props.field ? props.field.onChange : props.onChange;

  return (
    <div className={styles.container}>
      <label className={styles.switch}>
        <input
          data-testid={props.testId}
          type="checkbox"
          checked={checked}
          disabled={props.disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className={styles.slider}></span>
      </label>
      <span>{props.label}</span>
    </div>
  );
}
